import { ChartData, ChartOptions } from 'chart.js';
import React from 'react';
import { Line } from 'react-chartjs-2';
import merge from 'lodash/merge';
import { useTheme } from 'src/providers/ThemeProvider';
import { CHART_GRID, CHART_SERIES, CHART_TICK, chartMode } from 'src/styles/chartTheme';

// leaving this hardcoded.
export const lineChartDemoData = {
  labels: ['1.12', '2.12', '3.12', '4.12', '5.12', '6.12', '7.12', '8.12', '9.12'],
  datasets: [
    {
      data: [50, 150, 200, 22, 19, 166, 111, 67, 99],
      borderColor: CHART_SERIES.light[1],
    },
    {
      data: [150, 20, 90, 122, 37, 118, 65, 190, 123],
      borderColor: CHART_SERIES.light[3],
    },
  ],
};

export const defaultLineChartOptions: ChartOptions<'line'> = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: true,
      mode: 'index',
      intersect: false,
    },
  },
  elements: {
    point: {
      radius: 0,
      hoverRadius: 5,
    },
  },
  hover: {
    mode: 'nearest',
    intersect: false,
  },
  scales: {
    x: {
      grid: {
        drawOnChartArea: false,
        color: 'rgba(0, 0, 0, 0)',
      },
      border: {
        display: false,
      },
      ticks: {
        padding: 9,
        color: CHART_TICK,
      },
    },
    y: {
      min: 0,
      max: 200,
      ticks: {
        stepSize: 50,
        padding: 9,
        color: CHART_TICK,
      },
      border: {
        display: false,
      },
    },
  },
};

const LineChart: React.FC<{
  data: ChartData<'line', number[], string>;
  options?: Partial<ChartOptions<'line'>>;
}> = ({ data, options = defaultLineChartOptions }) => {
  const { theme } = useTheme();
  const gridColor = CHART_GRID[chartMode(theme)];
  const mergedOptions = merge({}, defaultLineChartOptions, { scales: { y: { grid: { color: gridColor } } } }, options);
  return (
    <div style={{ position: 'relative', width: '100%', contain: 'inline-size' }}>
      <Line data={data} options={mergedOptions} height="auto" width="auto" style={{ maxHeight: 200 }} />
    </div>
  );
};

export default LineChart;
